import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from '@services/api/api.service';
import { TaskService } from '@services/api/task.service';

@Component({
  selector: 'app-nav-task-manager',
  templateUrl: './nav-task-manager.component.html',
  styleUrls: ['./nav-task-manager.component.scss'],
})
export class NavTaskManagerComponent implements OnInit {
  @Output() sideTabtoggle = new EventEmitter<boolean>();
  @Input() job_type: boolean = false;
  @Input() status_tab: boolean = false;
  @Input() priority: boolean = false;
  // Price Manager
  @Output() priceManagerFilter = new EventEmitter<any>();
  @Output() priceManagerOfficesFilter = new EventEmitter<any>();
  @Input() offices: any;
  @Input() pms: any;
  searchedOffice = null;
  showJobType: boolean = true;
  showStatusType: boolean = true;
  showPriorityType: boolean = true;
  pm_id = -1;

  searchedPriorities: any;
  priorityQuery = '';
  checkToggleStatus = false;
  jobTypesSearched: any;
  searchQuery = '';
  SearchedStatuses: any;
  statusQuery = '';
  menuSideBar: boolean = false;
  subscription: any;

  constructor(
    private api: ApiService,
    private _taskService: TaskService
  ) {}

  ngOnInit() {
    this.getData();
    this.getStatusData();
    this.getPrioritiesData();
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  // job-type
  getData() {
    this._taskService.getTypes({ office_id: this.api.getOfficeId() }).subscribe(res => {
      this.jobTypesSearched = res.data;
    });
  }

  fetchBySearch() {
    this.api.get('/job-types?s=' + this.searchQuery, { office_id: this.api.getOfficeId() }).subscribe(res => {
      this.jobTypesSearched = res.data;
    });
  }
  // status
  getStatusData() {
    this._taskService.getStatuses({ office_id: this.api.getOfficeId() }).subscribe(res => {
      this.SearchedStatuses = res.data;
    });
  }
  fetchBySearchStatus() {
    this.api.get('/task-statuses?s=' + this.statusQuery, { office_id: this.api.getOfficeId() }).subscribe(res => {
      this.SearchedStatuses = res.data;
    });
  }

  // Priorites
  getPrioritiesData() {
    this._taskService.getPriorities({ office_id: this.api.getOfficeId() }).subscribe(res => {
      this.searchedPriorities = res.data;
    });
  }
  fetchPrioritiesBySearch() {
    this.api.get('/priorities?s=' + this.priorityQuery, { office_id: this.api.getOfficeId() }).subscribe(res => {
      this.searchedPriorities = res.data;
    });
  }

  tabToggle_method() {
    if (this.checkToggleStatus) {
      this.checkToggleStatus = false;
      this.sideTabtoggle.emit(false);
    } else {
      this.checkToggleStatus = true;
      this.sideTabtoggle.emit(true);
    }
  }

  // Price Manager
  eventPriceManager(pm) {
    this.priceManagerFilter.emit(pm);
  }
  eventFilterOffices() {
    this.priceManagerOfficesFilter.emit(this.searchedOffice);
  }
}
